import { useState } from "react";
import { Menu, X } from "lucide-react";
import { FREE_URL } from "../../lib/checkoutLinks";

const LINKS = [
  { href: "#features", label: "Features" },
  { href: "#how-it-works", label: "How It Works" },
  { href: "#plans", label: "Plans" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faq", label: "FAQ" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="relative z-50 backdrop-blur-xl bg-[#0A0A0B]/75 border-b border-[#232326]">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <span data-testid="navbar-logo" className="font-display text-2xl text-white tracking-wide">
          FORGE
        </span>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-[#A1A1AA] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={FREE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta-start-free"
          className="hidden lg:inline-flex items-center bg-[#C6FF3D] text-black font-semibold text-sm px-5 py-2.5 rounded-full hover:scale-105 hover:shadow-[0_0_24px_rgba(198,255,61,0.5)] transition-all duration-300"
        >
          Start Free
        </a>

        <button
          data-testid="navbar-mobile-menu-toggle"
          className="tap-target lg:hidden text-white flex items-center justify-center"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav data-testid="navbar-mobile-menu" className="lg:hidden flex flex-col gap-5 px-6 pb-6 bg-[#0A0A0B] border-t border-[#232326]">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-[#A1A1AA] hover:text-white text-sm"
            >
              {l.label}
            </a>
          ))}
          <a
            href={FREE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="tap-target flex items-center justify-center bg-[#C6FF3D] text-black font-semibold text-sm px-5 py-2.5 rounded-full text-center"
          >
            Start Free
          </a>
        </nav>
      )}
    </header>
  );
};
